"use client";

import AppButton from "../shared/AppButton";
import CommonInput from "../common/inputs/CommonInput";
import CommonTextarea from "../common/inputs/CommonTextarea";
import { useForm } from "react-hook-form";
import { Form } from "../ui/form";
import { ArrowUpRight, Loader2, Check } from "lucide-react";
import { useState } from "react";
interface ContactFormData {
  fullName: string;
  email: string;
  message: string;
}
const ContactForm = () => {
  const form = useForm<ContactFormData>();
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");
  const onSubmit = async (data: ContactFormData) => {
    setStatus("loading");
    setErrorMsg("");
    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });
      const result = await res.json();
      if (!res.ok) {
        throw new Error(result.error || "Something went wrong");
      }
      setStatus("success");
      form.reset();
      setTimeout(() => setStatus("idle"), 4000);
    } catch (err) {
      setStatus("error");
      setErrorMsg(err instanceof Error ? err.message : "Failed to send. Please try again.");
      setTimeout(() => setStatus("idle"), 4000);
    }
  };
  return <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-6">
        <CommonInput control={form.control} name="fullName" label="Name" type="text" placeholder="John Doe" />
        <CommonInput control={form.control} name="email" label="Email*" type="email" placeholder="Enter your email address" />
        <CommonTextarea control={form.control} name="message" label="Message*" placeholder="Write your message here..." rows={10} className="min-h-37.5" />
        <AppButton className="w-full" buttonClass="h-10" type="submit" disabled={status === "loading"}>
          {status === "loading" ? <>
              <Loader2 className="w-5 h-5 animate-spin" />
              <span>Sending...</span>
            </> : status === "success" ? <>
              <Check className="w-5 h-5" />
              <span>Sent Successfully!</span>
            </> : <>
              <span>Submit</span>
              <ArrowUpRight className="w-5 h-5 md:w-6 md:h-6" />
            </>}
        </AppButton>
        {status === "error" && <p className="text-red-500 text-sm text-center">{errorMsg}</p>}
      </form>
    </Form>;
};
export default ContactForm;